import React from 'react';
import Avatar from '@mui/material/Avatar';

const AvatarUI = ({ children }) => {
	return (
		<Avatar
			style={{
				margin: '10px auto',
				backgroundColor: '#1a6b7c'
			}}>
			{children}
		</Avatar>
	);
};

export default AvatarUI;
